/* eslint-disable */
/* 3rd party lib, not upgraded to code standards */
(function() {
	function e(b) {
		const ops =
			'scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,left=';
		b = b || window.event;
		for (
			var a = b.target || b.srcElement, c, d;
			a && a.nodeName.toLowerCase() !== 'a';

		)
			a = a.parentNode;
		a &&
			a.nodeName.toLowerCase() === 'a' &&
			a.href &&
			(c = a.href.match(g) || a.href.match(h) || a.href.match(k)) &&
			((c = Math.round(l / 2 - 275)),
			(d = 0),
			f > 420 && (d = Math.round(f / 2 - 210)),
			window.open(a.href, 'intent', ops + c + ',top=' + d),
			(b.returnValue = !1),
			b.preventDefault && b.preventDefault());
	}
	if (!window.__twitterIntentHandler) {
		var g = /twitter\.com\/intent\/(\w+)/;
		var h = /facebook\.com\/sharer\.php\?(\w+)/;
		var k = /pinterest\.com\/pin\/create\/(\w+)/;
		var f = screen.height;
		var l = screen.width;
		document.addEventListener
			? document.addEventListener('click', e, !1)
			: document.attachEvent && document.attachEvent('onclick', e);
		window.__twitterIntentHandler = !0;
	}
})();
